module.exports = {"id":"202986","name":"Sin Jin Ho","rating":"72","photo":"./data/images/photos/4/202986.png","club":{"name":"FC Séoul","logo":"./data/images/clubs/FCSeoul.png"},"positions":["MC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SinJinHo0.json
// module id = 3975
// module chunks = 0